export { default as Payments } from '../CardWalletApp';
